var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgUiWarningSolidLtr = function SvgUiWarningSolidLtr(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M58.85 15.729a11 11 0 0 0-3.959-3.96c-5.247-3.06-11.983-1.288-15.044 3.96L6.498 72.898A11 11 0 0 0 5 78.44c0 6.076 4.925 11 11 11h66.697a11 11 0 0 0 5.543-1.498c5.247-3.061 7.02-9.797 3.959-15.044zM50 62c-1.085 0-1.968-.924-2-2.077V33.14c0-1.182.895-2.14 2-2.14 1.085 0 1.968.924 2 2.077V59.86c0 1.182-.895 2.14-2 2.14m-4 9a4 4 0 1 1 8 0 4 4 0 0 1-8 0",
    clipRule: "evenodd"
  })));
};
export default SvgUiWarningSolidLtr;